// extracted by mini-css-extract-plugin
export default {"day":"oHrKU","daySelected":"ZWJ26","dayToday":"Cp0rY"};